/**
 * Calculate story age in hours from published date.
 * Uses Math.round() to match date-fns formatDistanceToNowStrict behavior.
 *
 * @param publishedDate - The date the story was published
 * @returns The age of the story in hours (rounded), or 0 for invalid/future dates
 *
 * @example
 * const ageInHours = calculateStoryAge('2024-01-01T00:00:00.000Z')
 * console.log(ageInHours) // e.g., 48
 */
export function calculateStoryAge(publishedDate: string | Date): number {
  const publishedTime = new Date(publishedDate)

  if (isNaN(publishedTime.getTime())) {
    return 0
  }

  const now = new Date()
  const differenceInMs = now.getTime() - publishedTime.getTime()

  // Clamp to 0 to prevent negative ages for future timestamps
  const clampedDifferenceInMs = Math.max(0, differenceInMs)

  return Math.round(clampedDifferenceInMs / (1000 * 60 * 60))
}
